/* RSI v2 · Black Week-kampanjen. Oppsett og gaver ligger i snippets/rsi-bw.liquid (window.RSI_BW). */
(function () {
  var C = window.RSI_BW; if (!C) return;
  var NO = C.lang === 'no', DA = C.lang === 'da';

  function qs(n) { var m = location.search.match(new RegExp('[?&]' + n + '=([^&#]*)')); return m ? decodeURIComponent(m[1]) : null; }
  try {
    var pv = qs('bw');
    if (pv) { if (pv === 'reset') sessionStorage.removeItem('rsi-bw-pv'); else sessionStorage.setItem('rsi-bw-pv', pv); }
    if (qs('tidlig') || qs('early')) localStorage.setItem('rsi-bw-early', '1');
  } catch (e) {}

  function day(s) { var p = s.split('-'); return new Date(+p[0], +p[1] - 1, +p[2]); }
  function phase() {
    var pv = null; try { pv = sessionStorage.getItem('rsi-bw-pv'); } catch (e) {}
    if (pv) return pv;
    var now = new Date(), ph = 'pre';
    C.ph.forEach(function (x) { if (now >= day(x[1])) ph = x[0]; });
    var early = false; try { early = localStorage.getItem('rsi-bw-early') === '1'; } catch (e) {}
    if (ph === 'warm' && early && now >= day(C.early)) ph = 'bw';
    return ph;
  }
  var PH = phase();
  function nextChange() {
    var now = new Date();
    for (var i = 0; i < C.ph.length; i++) { var d = day(C.ph[i][1]); if (d > now) return d; }
    return null;
  }
  var isBF = (function () { var n = new Date(), b = day(C.bf); return PH === 'bw' && n >= b && n < new Date(b.getTime() + 864e5); })();

  function money(kr) {
    if (NO) return String(Math.round(kr)).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' kr';
    if (DA) return String(dkn(kr)).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' kr';
    return '$' + String(Math.round(kr / 10)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  /* Samme omregning til DKK som Tilpass rejsen (rsi-p-tilpass-da.js) */
  function dkn(n) { n = Math.round(n); if (!n) return 0; var v = n * 0.72; if (n >= 5000 && n % 1000 === 900) return Math.round(v / 1000) * 1000 - 100; if (n % 100 === 99) return v >= 1000 ? Math.round(v / 100) * 100 - 1 : Math.round(v / 50) * 50 - 1; if (n % 50 === 49) return Math.round(v / 50) * 50 - 1; if (v >= 1000) return Math.round(v / 100) * 100; return Math.round(v / 10) * 10; }
  function gift(k) { return (C.g || {})[k] || null; }
  function giftOn() { return PH === 'bw' || PH === 'cm'; }
  function full(k) { return (['surf', 'wanderlust', 'padel', 'fitness'].indexOf(k) >= 0 ? 'Retreat-' : 'Pakkereise-') + k; }

  window.RSIBW = {
    phase: function () { return PH; }, giftOn: giftOn, gift: function (k) { return giftOn() ? gift(k) : null; },
    money: money,
    note: function () {
      if (PH === 'pre' || PH === 'off' || PH === 'warm') return '';
      if (document.getElementById('rsiP-tilpass')) return '';
      var k = window.RSI_PK || '', g = gift(k);
      return 'Black Week' + (g && g.v ? '-gave: ' + g.n + ' (' + g.s + ')' : ': opplevelsespakke på kjøpet') + ' · bestilt ' + new Date().toLocaleDateString('nb-NO');
    }
  };

  var T = DA ? {
    warm: 'Black Week Bali starter 23. november: oplevelser til en værdi af op til 3.500 kr for to. <u>Få adgang først</u>',
    bw: 'Black Week: oplevelser til en værdi af op til 3.500 kr for to, gratis til og med 30. november. <u>Se gaven til jeres rejse</u>',
    bf: 'Black Friday: oplevelser til en værdi af op til 3.500 kr for to, gratis. <u>Se gaven til jeres rejse</u>',
    cm: 'Sidste dag for Black Week-gaven: book i dag, og få en oplevelsespakke med. <u>Se gaven til jeres rejse</u>',
    close: 'Luk',
    tag: 'Black Week-gave: ', tagEnd: '',
    boxH: 'Black Week-gave', boxP: 'Book inden 30. november, og få ', boxV: 'Værdi ', boxFor: ' for to · gælder alle rejsende',
    boxW: 'Black Week 23.–30. november: ', boxW2: ' gratis ved booking. ', boxWl: 'Få adgang først'
  } : NO ? {
    warm: 'Black Week Bali starter 23. november: opplevelser verdt opptil 4 800 kr for to. <u>Få tilgang først</u>',
    bw: 'Black Week: opplevelser verdt opptil 4 800 kr for to, på kjøpet til og med 30. november. <u>Se gaven til din reise</u>',
    bf: 'Black Friday: opplevelser verdt opptil 4 800 kr for to, på kjøpet. <u>Se gaven til din reise</u>',
    cm: 'Cyber Monday: kjøp gavekort for 10 000 kr, få 1 000 kr gratis. Siste dag for Black Week-gaven. <u>Se tilbudet</u>',
    close: 'Lukk',
    tag: 'Black Week-gave: ', tagEnd: '',
    boxH: 'Black Week-gave', boxP: 'Book innen 30. november, så får dere ', boxV: 'Verdi ', boxFor: ' for to · gjelder alle reisende',
    boxW: 'Black Week 23.–30. november: ', boxW2: ' på kjøpet ved booking. ', boxWl: 'Få tilgang først'
  } : {
    warm: 'Black Week Bali starts 23 November: experiences worth up to $480 for two. <u>Get early access</u>',
    bw: 'Black Week: experiences worth up to $480 for two, free with your trip until 30 November. <u>See the gift for your trip</u>',
    bf: 'Black Friday: experiences worth up to $480 for two, free with your trip. <u>See the gift for your trip</u>',
    cm: 'Cyber Monday: buy a 10,000 kr gift card, get 1,000 kr free. Last day for the Black Week gift. <u>See the offer</u>',
    close: 'Close',
    tag: 'Black Week gift: ', tagEnd: '',
    boxH: 'Black Week gift', boxP: 'Book by 30 November and get ', boxV: 'Worth ', boxFor: ' for two · for every traveller',
    boxW: 'Black Week 23–30 November: ', boxW2: ' free when you book. ', boxWl: 'Get early access'
  };

  // ── Stripe øverst på alle sider (ikke på kampanjesiden)
  function ribbon() {
    if (C.page || ['warm', 'bw', 'cm'].indexOf(PH) < 0) return;
    try { if (sessionStorage.getItem('rsi-bw-x') === PH) return; } catch (e) {}
    var nav = document.querySelector('.rj .nav, header.nav'); if (!nav || document.querySelector('.bw-rib')) return;
    var d = document.createElement('div'); d.className = 'bw-rib';
    d.innerHTML = '<a href="' + C.url + '">' + (isBF ? T.bf : T[PH]) + '</a><button type="button" aria-label="' + T.close + '">×</button>';
    d.querySelector('button').onclick = function () { d.remove(); try { sessionStorage.setItem('rsi-bw-x', PH); } catch (e) {} };
    nav.parentNode.insertBefore(d, nav.nextSibling);
  }

  // ── Merke på pakkekortene
  function path(u) { try { return new URL(u, location.href).pathname.replace(/\/$/, ''); } catch (e) { return u; } }
  function badges() {
    if (!giftOn()) return;
    var L = window.RSI_LINKS || {};
    Object.keys(C.g).forEach(function (k) {
      var g = C.g[k]; if (!g.v) return;
      var fk = full(k), want = L[fk] ? path(L[fk]) : null;
      document.querySelectorAll('a.pc, a.pkg-card').forEach(function (a) {
        if (a.querySelector('.bw-tag')) return;
        var h = a.getAttribute('href') || '';
        if (!(h.indexOf(fk + '.dc.html') >= 0 || (want && path(h) === want))) return;
        var b = a.querySelector('.pc-b, .pkg-body') || a;
        var s = document.createElement('span'); s.className = 'bw-tag'; s.textContent = T.tag + g.n + T.tagEnd;
        b.insertBefore(s, b.firstChild);
      });
    });
  }

  // ── Boks på produktsiden
  function box() {
    var k = window.RSI_PK; if (!k) return;
    var g = gift(k); if (!g || !g.v) return;
    var html = '';
    if (giftOn()) html = '<b>' + T.boxH + '</b><p>' + T.boxP + '<strong>' + g.n + '</strong>: ' + g.s + '.</p><small>' + T.boxV + money(g.v * 2) + T.boxFor + '</small>';
    else if (PH === 'warm') html = '<b>' + T.boxH + '</b><p>' + T.boxW + '<strong>' + g.n + '</strong>' + T.boxW2 + '<a href="' + C.url + '">' + T.boxWl + '</a></p>';
    if (!html) return;
    document.querySelectorAll('.price-l, .side-in .pr').forEach(function (el) {
      if (el.nextElementSibling && el.nextElementSibling.classList.contains('bw-box')) return;
      var d = document.createElement('div'); d.className = 'bw-box' + (el.classList.contains('pr') ? ' sm' : ''); d.innerHTML = html;
      el.parentNode.insertBefore(d, el.nextSibling);
    });
  }

  // ── Kampanjesiden: vis riktig fase og nedtelling
  function page() {
    var root = document.getElementById('rsiBW'); if (!root) return;
    var show = PH === 'pre' ? 'warm' : PH;
    root.setAttribute('data-phase', show);
    root.querySelectorAll('[data-bw]').forEach(function (el) {
      var on = (' ' + el.getAttribute('data-bw') + ' ').indexOf(' ' + show + ' ') >= 0;
      el.hidden = !on;
    });
    root.querySelectorAll('[data-bw-v]').forEach(function (el) { el.textContent = money(+el.getAttribute('data-bw-v')); });
    root.querySelectorAll('[data-act]').forEach(function (el) { el.classList.toggle('on', (' ' + el.getAttribute('data-act') + ' ').indexOf(' ' + show + ' ') >= 0); });
    var cd = root.querySelectorAll('[data-bw-cd]');
    if (!cd.length) return;
    function tick() {
      cd.forEach(function (el) {
        var v = el.getAttribute('data-bw-cd'), end = v ? day(v) : nextChange(); if (!end) return;
        var s = Math.max(0, Math.floor((end - new Date()) / 1000));
        var d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), m = Math.floor(s % 3600 / 60);
        el.textContent = (d ? d + (NO || DA ? ' d ' : 'd ') : '') + h + (NO || DA ? ' t ' : 'h ') + m + ' min';
      });
    }
    tick(); setInterval(tick, 30000);
  }

  function run() { ribbon(); badges(); box(); page(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  var tm = null;
  var mo = new MutationObserver(function () { clearTimeout(tm); tm = setTimeout(function () { badges(); box(); }, 120); });
  function watch() { mo.observe(document.body, { childList: true, subtree: true }); setTimeout(function () { mo.disconnect(); }, 15000); }
  if (document.body) watch(); else document.addEventListener('DOMContentLoaded', watch);
})();